import React, { useRef, useState, useEffect } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import SchoolIcon from '@mui/icons-material/School';
import profile1 from '../../Assets/img/student.jpg';
import collegepic from '../../Assets/img/college.jpg';
import iconimg1 from '../../Assets/img/icon-img1.jpg';
import iconimg2 from '../../Assets/img/icon-img1.jpg';
import bg from '../../Assets/img/bg.jpg';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';

import widget from '../../Assets/img/widget.svg';
import hand from '../../Assets/img/hand.svg';
import Api from "../../component/Api";
import { formatDistanceToNow, parseISO } from 'date-fns';
import useAuth from '../../component/useAuth';
import { useNavigate } from 'react-router-dom';

const Home = () => {

  const [activeRecordsCountSpec, setActiveRecordsCountSpec] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isviewlog, setViewLog] = useState(true);
  const [userlog, setUserLogData] = useState([]);
  const [flag, setflag] = useState(0);

  const [inst, setInst] = useState([]);

  const [msgtatus, setStatus] = useState(null);

  const [enteredCount, setEnteredCount] = useState(0);  // To store the count of "Entered"
  const [notOptedCount, setNotOptedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [activecoTab, setActiveCoTab] = useState('semester1');
  const [studentData, setStudentData] = useState({});
  const [getStudentSwitchStatData, setStudentSwitchStatData] = useState([]);
  const [markDetails, setMarkDetails] = useState(null);
  const [studentCreditData, setStudentCreditData] = useState(null);
  const [disciplinewiseCreditData, setDisciplinewiseCreditData] = useState(null);

  // --- NEW STATE FOR SWITCHING ---
  // const [relatedAccounts, setRelatedAccounts] = useState([]);
  // const [isSwitching, setIsSwitching] = useState(false);
  // -------------------------------

  const [semesterData, setSemesterData] = useState([]);
  const [profile, setProfile] = useState('');
  const { http } = Api();

  const isAuth = useAuth();
  const navigate = useNavigate();

  if (isAuth === false) {
    navigate("/")
  }

  // --- NEW: FETCH RELATED ACCOUNTS ---
  // useEffect(() => {
  //   const fetchRelated = async () => {
  //     try {
  //       const res = await http.get('/get-related-accounts');
  //       if (res.data.accounts && res.data.accounts.length > 0) {
  //         setRelatedAccounts(res.data.accounts);
  //       }
  //     } catch (err) {
  //       // Silently fail if no related accounts or API error, 
  //       // as this isn't critical for the main dashboard
  //       console.error("Could not fetch related accounts", err);
  //     }
  //   };
  //   fetchRelated();
  // }, []);

  // // --- NEW: HANDLE SWITCH ACTION ---
  // const handleSwitchProfile = async (targetId) => {
  //   const confirmSwitch = window.confirm("Are you sure you want to switch to this profile?");
  //   if (!confirmSwitch) return;

  //   setIsSwitching(true);

  //   try {
  //     const res = await http.post('/switch-profile', { target_account_id: targetId });

  //     if (res.data.status === 'success') {
  //       toast.success("Switching Profile...");

  //       // 1. Update Token
  //       localStorage.setItem('token', res.data.token);

  //       // 2. Force Axios to use new token immediately (optional safety step)
  //       if(http.defaults) {
  //            http.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
  //       }

  //       // 3. Reload Page to refresh all data with new user context
  //       setTimeout(() => {
  //            window.location.reload();
  //       }, 1000);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     toast.error(error.response?.data?.message || "Switching failed");
  //     setIsSwitching(false);
  //   }
  // };


  const handleCoTabClick = (tab, semesterId) => {
    setActiveCoTab(tab);
    fetchSemesterData(semesterId);
  };


  const fetchSemesterData = async (semesterId) => {

    try {
      const response = await http.get('Student/viewStudentCourseSemWise', {
        params: { semester_id: semesterId }
      });
      const studentDetailscourse = response.data.studentDetailscourse;
      setSemesterData(studentDetailscourse);
      const enteredCount = studentDetailscourse.filter(course => course.studentstatus === 'Entered').length;
      const notOptedCount = studentDetailscourse.filter(course => course.studentstatus === 'Not Opted').length;
      setEnteredCount(enteredCount);
      setNotOptedCount(notOptedCount);

      // Set total count of courses
      setTotalCount(studentDetailscourse.length);

    } catch (error) {
      if (error.response && error.response.data && error.response.data.http_status === 500 && error.response.data.status_code === "ERR5") {

        setSemesterData([]); // Set empty array
        toast.error("Semeter data not found");

      }
      else if (error.response.data.http_status === 401) {
        toast.error("Invalid token");
        setTimeout(() => {
          navigate('/');
        }, 5000);
      }
      else {
        toast.error("Something went wrong");
      }

    }
  };

  // Initial data fetch for Semester 1
  useEffect(() => {
    fetchSemesterData(1); // Default semester ID for "Sem 1"
  }, []);

  useEffect(() => {
    const { http } = Api();
    const studentdata = async () => {
      try {
        const response = await http.get('/Student/getStudentprofile');
        setStudentData(response.data.studentdata[0]);
        setStudentSwitchStatData(response.data.studentdata[0].switch_stat);

        setProfile(response.data.studentdata[0].studentphoto.original.base64_image);
        setMarkDetails(response.data.markdetails);
      } catch (error) {
        if (error.response?.data?.http_status === 401) {
          toast.error('Invalid token');
          setTimeout(() => navigate('/'), 5000);
        } else {
          // toast.error('Error fetching Student data');
        }
      }
    };

    studentdata();
    //fetchstudentExamregData(1); // Fetch data for the first semester on load
  }, []);

  {/* New API for fetch student details End */ }
  useEffect(() => {
    const getCreditHistory = async () => {
      http.get('/Student/getStudentCreditHistory', {
        params:
        {
          account_id: studentData.accountid,
        }
      }).then((response) => {
        setStudentCreditData(response.data.studentCreditData || []);
      }).catch((error) => {
        if (!error.response) {
          toast.error('Server not reachable');
          return;
        }
        const { http_status, message } = error.response.data;

        if (http_status === 401) {
          toast.error(message || 'Invalid Token');
          setTimeout(() => navigate('/'), 3000);
        } else if (http_status === 422) {
          toast.error(message || 'Validation failed');
        } else if (http_status === 500) {
          toast.error(message || 'Credit Data not found');
        } else {
          toast.error('Unexpected error occurred');
        }
      })
    };
    if (studentData?.accountid) {
      setStudentCreditData(null);
      getCreditHistory();
    }
  }, [studentData?.accountid])




  useEffect(() => {
    const getDisciplinewiseCreditHistory = async () => {
      http.get('/Student/getDisciplinewiseCreditHistory', {
        params:
        {
          account_id: studentData.accountid,
        }
      }).then((response) => {
        if (!response.data.studentDisciplinewiseCreditData) {
          toast.error("Credit marks not found");
          setDisciplinewiseCreditData(null);
        }
        setDisciplinewiseCreditData(response.data.studentDisciplinewiseCreditData || []);
      }).catch((error) => {
        if (!error.response) {
          toast.error('Server not reachable');
          return;
        }
        const { http_status, message } = error.response.data;

        if (http_status === 401) {
          toast.error(message || 'Invalid Token');
          setTimeout(() => navigate('/'), 3000);
        } else if (http_status === 422) {
          toast.error(message || 'Validation failed');
        } else if (http_status === 500) {
          toast.warning(message || 'Data not found');
        } else {
          toast.error('Unexpected error occurred');
        }
      })
    };
    if (studentData?.accountid) {
      getDisciplinewiseCreditHistory(null);

    }
  }, [studentData?.accountid])

  const totalCredits = disciplinewiseCreditData?.reduce(
    (sum, item) => sum + Number(item.total_acquired_credit || 0),
    0
  ) || 0;

  const totalDisciplines = disciplinewiseCreditData?.length ? new Set(disciplinewiseCreditData.map(item => item.discipline_name)).size : 0;


  console.log("disciplinewiseCreditData", disciplinewiseCreditData)

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hour}:${minute}`;
  }
  const formatRelativeDate = dateString => {
    const parsedDate = parseISO(dateString);
    return formatDistanceToNow(parsedDate, { addSuffix: true });
  };




  useEffect(() => {
    const fetchData = async () => {

      const { http } = Api();
      const id1 = localStorage.getItem("id");

      await http.get(`/Admin/getRecentUserActions/${id1}`).then(response => {
        if (response.data.recentUserActions) {
          setUserLogData(response.data.recentUserActions);
          setflag(1);
        }
        else {
          setflag(0);
        }
      }).catch(error => {
        // console.error('Error fetching user log data:', error);
        setflag(0);
      })

      try {
        const response1 = await http.get(`/Admin/getNotificationsAndMessages`);

        if (response1.data.status_code !== "ERR5") {

          setInst(previous => {
            const filteredinstruction = response1.data.filter(option => option.msg_type === 'instruction');

            return filteredinstruction;
          });
        }
        else {

          setInst([]);

        }
      }
      catch (error) {
        if (error.response.data.http_status === 401) {
          toast.error("Invalid token");
          setTimeout(() => {
            navigate('/');
          }, 5000);
        }
        else {

          // console.error("Error in fetch Student data:", error);
          toast.error("Something went wrong: ");
        }
      }
    };
    if (isAuth) {
      fetchData();
    }

  }, []);





  return (
    <>
      <StudentTemplate>
        <ToastContainer />


        <div className="container-fluid">
          <div className="row">
            <div className="col-12 mb-4 ml-5" style={{ marginLeft: "5px" }}>
              <div className="card o-hidden welcome-card course-box">
                <div className="col-sm-12 m-b-0 mb-4" >
                  <div className="card o-hidden welcome-card " style={{ marginBottom: "0px" }}>
                    <div className="card-body" style={{ background: "linear-gradient(135deg, #2c3e50, #3498db)", }}>
                      <h4 className="mb-3 mt-1 f-w-500 mb-0 f-22 st-ft-clr">Hello {studentData.studentname ? studentData.studentname : 'Student Name'} &nbsp;<span> <img src={hand} alt="hand vector" /></span></h4>

                      {getStudentSwitchStatData && (getStudentSwitchStatData === 'college_transfer_only' || getStudentSwitchStatData === 'major_college_change') ? (

                        <p className="st-ft-clr">

                          <div className="college-info-row">
                            <div className="activity-dot-primary activity-dot-primary-li">
                            </div>
                            <h6 className="college-name">
                              {studentData.switched_college_name} <span className="transferred-highlight"> (Transferred)</span><br />

                            </h6></div>
                        </p>

                      ) : (
                        <p className="st-ft-clr"> <h6><div className="activity-dot-primary activity-dot-primary-li"></div>{studentData.college_name} <br /></h6></p>

                      )
                      }
                      <h6 className="st-ft-clr"><div className="activity-dot-primary activity-dot-primary-li"></div>{studentData.discipline_name} Department</h6>
                    </div>
                    <img className="welcome-img" src={widget} alt="search image" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-12 order-2 order-xl-3">
              <div className="card card1 course-box mb-3">
                <div className="card-body">
                  <div className="social-img-wrap mt-17 st-mar col-st-image-wrap mb-5">
                    <div className="social-img col-st-image-prof">
                      <img src={profile} alt="profile" className="prof-img-ht zoom-img" />
                    </div>
                    <div className="edit-icon col-img-rt mb">
                      <svg className="st-act-btn">
                        <use href="../assets/svg/icon-sprite.svg#profile-check"></use>
                      </svg>
                    </div>
                  </div>
                  <div className="social-details m-t-0">
                    <div className="media-body prof-bak-clr">
                      <h5 className="mb-1">{studentData.studentname}</h5>
                      <h6 className="mb-1">Cap Id : {studentData.accountid}</h6>
                      {/* <div className="lang">{studentData.specialisation_display_name}</div> */}
                      {getStudentSwitchStatData && (getStudentSwitchStatData === 'major_change_only' || getStudentSwitchStatData === 'major_college_change') ? (

                        <div className="lang m-b-2">{studentData.switched_major_name}<span className="transferred-highlight transfer-txt">(Major Switched)</span></div>
                      ) : (
                        <div className="lang">{studentData.specialisation_display_name}</div>

                      )}
                      {studentData.currentsemester && (
                        <div className="lang">
                          {studentData.currentsemester}
                          <sup>
                            {(() => {
                              const s = studentData.currentsemester;
                              if (s === 1) return "st";
                              if (s === 2) return "nd";
                              if (s === 3) return "rd";
                              return "th";
                            })()}
                          </sup> Sem
                        </div>
                      )}
                    </div>

                    {/* --- ACCOUNT SWITCHER UI --- */}
                    {/* {relatedAccounts.length > 0 && (
                        <div className="mt-3 text-center" style={{borderTop: '1px solid #eee', paddingTop: '15px'}}>
                           <label className="mb-2 text-muted" style={{fontSize: '12px'}}>Other Profiles</label>
                           <div className="dropdown">
                              <button 
                                className="btn btn-outline-primary btn-sm dropdown-toggle w-100" 
                                type="button" 
                                id="accountSwitcher" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                                disabled={isSwitching}
                              >
                                {isSwitching ? (
                                    <span><span className="spinner-border spinner-border-sm me-2"></span>Switching...</span>
                                ) : (
                                    <span><i className="bi bi-people-fill me-2"></i> Switch Profile</span>
                                )}
                              </button>
                              <ul className="dropdown-menu w-100" aria-labelledby="accountSwitcher">
                                {relatedAccounts.map((acc, idx) => (
                                    <li key={idx}>
                                        <button 
                                            className="dropdown-item d-flex justify-content-between align-items-center" 
                                            onClick={() => handleSwitchProfile(acc.accountid)}
                                            style={{cursor: 'pointer'}}
                                        >
                                            <div style={{display:'flex', flexDirection:'column'}}>
                                                <span style={{fontWeight:'500', fontSize:'13px'}}>
                                                    {acc.discipline_name || acc.studentname}
                                                </span>
                                                <span style={{fontSize:'11px', color:'#777'}}>
                                                    {acc.college_name || `ID: ${acc.accountid}`}
                                                </span>
                                            </div>
                                            
                                            <span className={`badge rounded-pill ${acc.status === 'active' ? 'bg-success' : 'bg-secondary'}`} style={{fontSize:'10px'}}>
                                                {acc.status}
                                            </span>
                                        </button>
                                    </li>
                                ))}
                              </ul>
                           </div>
                        </div>
                    )} */}
                    {/* --- END SWITCHER UI --- */}

                  </div>
                </div>


              </div>

            </div>

            <div className="col-xl-8 col-12 order-3 order-xl-2">
              {isviewlog && (


                <div className="col-12 order-3 order-md-2">
                  <div className="card shadow-sm">
                    <div className="card-body">
                      <div class="d-flex align-items-center mb-4">
                        <h3 class="mb-0 text-dark mobile">
                          <i class="bi bi-megaphone-fill me-2 text-primary "></i>
                          Instructions
                        </h3>
                      </div>

                      <div className="instructions-container overflow-auto  activity-scroll-container activity-scroll-bar-container" style={{ maxHeight: "260px", minHeight: "260px" }}>
                        {Array.isArray(inst) && inst.length > 0 ? (
                          inst.filter(instns => new Date(instns.msg_exp_time).getTime() >= new Date().getTime()).length > 0 ? (
                            inst.filter(instns => new Date(instns.msg_exp_time).getTime() >= new Date().getTime()).map((instns, index) => (
                              <div key={index} className={`alert ${index % 2 === 0 ? 'alert-light-success' : 'alert-light-primary'}`} role="alert">
                                <div style={{ position: 'absolute', top: '10px', right: '10px', fontSize: 'smaller', color: 'gray' }}>
                                  {new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit' }).format(new Date(instns.msg_sent_time))}
                                </div>
                                <br />
                                <h5 className="alert-heading">{instns.subject}</h5>
                                <p style={{ display: 'inline' }}>
                                  {instns.status === 'sent' ? <label className="badge badge-light-secondary pull-right">New</label> : ''}
                                  <span style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: instns.message.replace(/\r\n/g, '<br />') }}></span>
                                </p>
                              </div>
                            ))
                          ) : (
                            <div class="text-center py-5">
                              <i class="bi bi-info-circle-fill text-muted fs-1 mb-3 d-block"></i>
                              <h4 class="text-dark">No Instructions Available</h4>
                              <p class="text-muted">Currently, there are no instructions for you to review. Please check back later.</p>
                            </div>
                          )
                        ) : (
                          <div class="text-center py-5">
                            <i class="bi bi-info-circle-fill text-muted fs-1 mb-3 d-block"></i>
                            <h4 class="text-dark">No Instructions Available</h4>
                            <p class="text-muted">Currently, there are no instructions for you to review. Please check back later.</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}



            </div>



            <div className="col-xxl-12 col-xl-12 box-col-4 mb-0 order-5 order-md-5">

              {/* Discipline/College wsitch history */}
              <div className="card card-body">
                <div className="accordion switch-exam-ui" id="switchAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="switchHeading">
                      <button
                        className="accordion-button accordion-button-sz switch2-head credit-mark-bak-clr"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#switchCollapse"
                        aria-expanded="ture"
                        aria-controls="switchCollapse"
                      >
                        <span className="switch2-icon blue-toggle-icon">
                          <i className="bi bi-chevron-down accordion-icon-collapsed"></i>
                          <i className="bi bi-chevron-up accordion-icon-expanded"></i>
                        </span>
                        Acquired Credits
                      </button>
                    </h2>

                    <div
                      id="switchCollapse"
                      className="accordion-collapse collapse show"
                      aria-labelledby="switchHeading"
                      data-bs-parent="#switchAccordion"
                    >
                      <div className="accordion-body">
                        {/* Discipline/College switch history */}
                        {studentCreditData === null && (
                          <div className="text-center py-3">
                            Loading credit marks...
                          </div>
                        )}

                        {studentCreditData?.length > 0 && (() => {
                          // Sort by switch_sequence to ensure proper order
                          const sortedData = [...studentCreditData].sort((a, b) => a.switch_sequence - b.switch_sequence);

                          return (
                            <>
                              <ul className="switch-timeline">
                                {sortedData.map((creditdata, index) => {
                                  const hasPrevious =
                                    creditdata.previous_college ||
                                    creditdata.previous_discipline_name ||
                                    creditdata.previous_discipline;

                                  // 👉 NEW — comparison variables you asked for
                                  const collegeChanged =
                                    creditdata.previous_college &&
                                    creditdata.current_college &&
                                    creditdata.previous_college !== creditdata.current_college;

                                  const disciplineChanged =
                                    (creditdata.previous_discipline || creditdata.previous_discipline_name) &&
                                    (creditdata.current_discipline || creditdata.current_discipline_name) &&
                                    (creditdata.previous_discipline !== creditdata.current_discipline ||
                                      creditdata.previous_discipline_name !== creditdata.current_discipline_name);

                                  // Check if this is the latest switch (highest sequence)
                                  const isLatest = index === sortedData.length - 1;

                                  return (
                                    <li
                                      className={`switch-item ${isLatest ? "switch-latest-highlight" : ""}`}
                                      key={creditdata.switch_sequence || index}
                                    >

                                      <div className="switch-card">
                                        {/* Header showing switch number */}
                                        <div className="switch-sequence-header">
                                          <span className="switch-badge">
                                            <i className="bi bi-arrow-left-right me-1"></i>
                                            Switch {creditdata.switch_sequence || index + 1}
                                            {collegeChanged || disciplineChanged ? " (" : ""}
                                            {collegeChanged && !disciplineChanged
                                              ? "College Changed"
                                              : !collegeChanged && disciplineChanged
                                                ? "Discipline Changed"
                                                : collegeChanged && disciplineChanged
                                                  ? "College & Discipline Changed"
                                                  : ""}
                                            {collegeChanged || disciplineChanged ? ")" : ""} </span>
                                        </div>

                                        {/* Single College (no previous) - First switch only */}
                                        {!hasPrevious && index === 0 && (
                                          <div className="no-switch-container">
                                            <div className="row justify-content-center">
                                              <div className="col-11 col-md-10 col-lg-9">

                                                {/* --- SINGLE CURRENT COLLEGE CARD (No Switch) --- */}
                                                <div className="no-switch-card light-green-card w-90 switch-latest-highlight">

                                                  <div className="no-switch-header d-flex justify-content-between align-items-center">

                                                    <div className="current-status-badge">
                                                      <i className="bi bi-check-circle-fill me-2"></i>
                                                      <span>CURRENT COLLEGE</span>
                                                    </div>

                                                    <div className="no-switch-credits-box text-end">
                                                      <div className="no-switch-credit-number">
                                                        {creditdata.total_acquired_credit}
                                                      </div>
                                                      <span className="no-switch-credit-unit">CREDITS</span>
                                                    </div>

                                                  </div>

                                                  <div className="no-switch-divider"></div>

                                                  <div className="no-switch-content">
                                                    <p className="no-switch-college mb-1">
                                                      {creditdata.current_college}
                                                    </p>
                                                    <small className="no-switch-discipline text-muted">
                                                      {creditdata.current_discipline}
                                                    </small>
                                                  </div>

                                                </div>
                                                {/* --- END SINGLE CARD --- */}

                                              </div>
                                            </div>
                                          </div>
                                        )}


                                        {/* Switch with Previous - For all switches except first if no previous */}
                                        {hasPrevious && (collegeChanged || disciplineChanged) && (

                                          <>
                                            {/* Mobile layout */}
                                            <div className="table-responsive d-md-none">
                                              <div className="switch-row stylish-row responsive-switch switch-mobile-layout">

                                                {/* CURRENT - MOBILE */}
                                                <div className="switch-side new-side stylish-side credit-box-parent responsive-card modern-credit-card mobile-credit-card current-green-card">
                                                  <div className="credit-header modern-credit-header">
                                                    <span className="side-badge new modern-badge current-green-badge m-r-5">
                                                      <i className={`bi ${isLatest ? 'bi-check-circle-fill' : 'bi-clock-history'} me-1`}></i>
                                                      {isLatest ? 'CURRENT COLLEGE' : 'NEXT COLLEGE'}
                                                    </span>
                                                    <div className="credit-box-wrapper squared-credit-box">
                                                      <div className="credit-summary-box modern-credit-number squared-credit-number current-green-number">
                                                        {creditdata.current_credit || creditdata.current_discipline_credit}
                                                      </div>
                                                      <span className="credit-unit squared-credit-unit">CREDITS</span>
                                                    </div>
                                                  </div>

                                                  <div className="credit-content modern-credit-content">
                                                    <p
                                                      className={`college-title modern-college-title ${collegeChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.current_college}
                                                    </p>

                                                    <small
                                                      className={`discipline-text modern-discipline-text ${disciplineChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.current_discipline || creditdata.current_discipline_name}
                                                    </small>

                                                  </div>
                                                </div>

                                                {/* CENTER - MOBILE */}
                                                <div className="switch-center responsive-center switch-center-mobile">
                                                  <div className="modern-switch-connector">
                                                    <div className="connector-line"></div>
                                                    <span className="switch-icon-badge modern-switch-icon simple-switch-icon">
                                                      <i className="bi bi-arrow-left"></i>
                                                    </span>
                                                    <div className="connector-line"></div>
                                                  </div>
                                                </div>

                                                {/* PREVIOUS - MOBILE */}
                                                <div className="switch-side old-side stylish-side credit-box-parent responsive-card modern-credit-card mobile-credit-card previous-gray-card">
                                                  <div className="credit-header modern-credit-header">
                                                    <span className="side-badge old modern-badge previous-gray-badge">
                                                      <i className={`bi ${index === 0 ? 'bi-building' : 'bi-clock-history'} me-1`}></i>
                                                      {index === 0 ? 'PREVIOUS COLLEGE' : 'FROM COLLEGE'}
                                                    </span>
                                                    <div className="credit-box-wrapper squared-credit-box">
                                                      <div className="credit-summary-box modern-credit-number squared-credit-number previous-gray-number">
                                                        {creditdata.previous_credit || creditdata.previous_discipline_credit}
                                                      </div>
                                                      <span className="credit-unit squared-credit-unit">CREDITS</span>
                                                    </div>
                                                  </div>

                                                  <div className="credit-content modern-credit-content">
                                                    <p
                                                      className={`college-title modern-college-title ${collegeChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.previous_college}
                                                    </p>
                                                    <small
                                                      className={`discipline-text modern-discipline-text ${disciplineChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.previous_discipline || creditdata.previous_discipline_name}
                                                    </small>


                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Desktop layout */}
                                            <div className="d-none d-md-block modern-desktop-layout">
                                              <div className="switch-row stylish-row responsive-switch modern-switch-row current-first-desktop">

                                                {/* CURRENT - Desktop */}
                                                <div className="switch-side new-side stylish-side credit-box-parent responsive-card modern-credit-card desktop-credit-card current-green-card">
                                                  <div className="credit-header modern-credit-header">
                                                    <span className="side-badge new modern-badge current-green-badge m-r-5">
                                                      <i className={`bi ${isLatest ? 'bi-check-circle-fill' : 'bi-clock-history'} me-1`}></i>
                                                      {isLatest ? 'CURRENT COLLEGE' : 'NEXT COLLEGE'}
                                                    </span>
                                                    <div className="credit-box-wrapper squared-credit-box">
                                                      <div className="credit-summary-box modern-credit-number squared-credit-number current-green-number">
                                                        {creditdata.current_credit || creditdata.current_discipline_credit}
                                                      </div>
                                                      <span className="credit-unit squared-credit-unit">CREDITS</span>
                                                    </div>
                                                  </div>

                                                  <div className="credit-content modern-credit-content">
                                                    <p
                                                      className={`college-title modern-college-title ${collegeChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.current_college}
                                                    </p>

                                                    <small
                                                      className={`discipline-text modern-discipline-text ${disciplineChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.current_discipline || creditdata.current_discipline_name}
                                                    </small>
                                                  </div>
                                                </div>

                                                {/* CENTER - Desktop */}
                                                <div className="switch-center responsive-center modern-switch-center">
                                                  <div className="modern-desktop-connector">
                                                    <div className="connector-line desktop-line current-to-center"></div>
                                                    <span className="switch-icon-badge modern-switch-icon desktop-switch-icon simple-switch-icon">
                                                      <i className="bi bi-arrow-left"></i>
                                                    </span>
                                                    <div className="connector-line desktop-line center-to-previous"></div>
                                                  </div>
                                                </div>

                                                {/* PREVIOUS - Desktop */}
                                                <div className="switch-side old-side stylish-side credit-box-parent responsive-card modern-credit-card desktop-credit-card previous-gray-card">
                                                  <div className="credit-header modern-credit-header">
                                                    <span className="side-badge old modern-badge previous-gray-badge">
                                                      <i className={`bi ${index === 0 ? 'bi-building' : 'bi-clock-history'} me-1`}></i>
                                                      {index === 0 ? 'PREVIOUS COLLEGE' : 'FROM COLLEGE'}
                                                    </span>
                                                    <div className="credit-box-wrapper squared-credit-box">
                                                      <div className="credit-summary-box modern-credit-number squared-credit-number previous-gray-number">
                                                        {creditdata.previous_credit || creditdata.previous_discipline_credit}
                                                      </div>
                                                      <span className="credit-unit squared-credit-unit">CREDITS</span>
                                                    </div>
                                                  </div>

                                                  <div className="credit-content modern-credit-content">
                                                    <p
                                                      className={`college-title modern-college-title ${collegeChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.previous_college}
                                                    </p>
                                                    <small
                                                      className={`discipline-text modern-discipline-text ${disciplineChanged ? "highlight-change" : ""
                                                        }`}
                                                    >
                                                      {creditdata.previous_discipline || creditdata.previous_discipline_name}
                                                    </small>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}

                                        {/* Add connector between switches except for the last one */}
                                        {index < sortedData.length - 1 && (
                                          <div className="switch-connector-between">
                                            <div className="connector-line-between"></div>
                                            <div className="connector-arrow-between">
                                              <i className="bi bi-arrow-down"></i>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>

                              {/* TOTAL CREDIT SECTION - Only show once at the bottom */}
                              {sortedData.length > 0 && (
                                <div className="row mt-4">
                                  <div className="col-12 d-flex justify-content-center">
                                    <div className="total-credit-wrapper">
                                      <div
                                        className="total-credit-card modern-total-card total-blue-card clickable-total-card"
                                        data-bs-toggle="modal"
                                        data-bs-target="#creditDetailsModal"
                                        style={{ cursor: 'pointer' }}
                                      >
                                        <div className="total-credit-icon modern-total-icon">
                                          <i className="bi bi-trophy-fill"></i>
                                        </div>

                                        <div className="total-credit-content">
                                          <span className="total-credit-label modern-total-label">
                                            TOTAL ACQUIRED CREDITS
                                            <i className="bi bi-chevron-right ms-2 click-indicator"></i>
                                          </span>
                                          <div className="total-credit-box-wrapper">
                                            <h3 className="total-credit-value modern-total-value">
                                              {sortedData[0].total_acquired_credit}
                                            </h3>
                                            <span className="total-credit-unit squared-total-unit">Credits</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        })()}



                        {/* Total Credit Details Modal */}
                        {/* {disciplinewiseCreditData && disciplinewiseCreditData.length > 0 && (


                          <div className="modal fade" id="creditDetailsModal" tabIndex="-1" aria-labelledby="creditDetailsModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content credit-details-modal">
                                <div className="modal-header credit-modal-header" style={{ background: "linear-gradient(135deg, #2196f3, #1976d2) !important" }}>
                                  <h5 className="modal-title credit-modal-title" id="creditDetailsModalLabel">
                                    <i className="bi bi-list-check me-2"></i>
                                    <span className="modal-title-text">Credit Details</span>
                                  </h5>
                                  <button type="button" className="btn-close credit-modal-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                                </div>
                                <div className="modal-body credit-modal-body">

                              
                                  <div className="total-summary-box mb-4">
                                    <div className="total-summary-header">
                                      <i className="bi bi-pie-chart-fill me-2"></i>
                                      <span className="summary-header-text">Overall Summary</span>
                                    </div>
                                    <div className="total-summary-content">
                                      <div className="total-summary-item">
                                        <span className="summary-label">Disciplines</span>
                                        <span className="summary-value"> {totalDisciplines}</span>
                                      </div>
                                      <div className="total-summary-item">
                                        <span className="summary-label">Total Credits</span>
                                        <span className="summary-value total-highlight"> {totalCredits}</span>
                                      </div>

                                    </div>
                                  </div>

                                
                                  <div className="credit-breakdown-table-container">
                                    <div className="table-header">
                                      <h6 className="table-title">
                                        <i className="bi bi-table me-2"></i>
                                        <span className="table-title-text">Discipline-wise Credits</span>
                                      </h6>
                                    </div>

                                    <div className="table-responsive">
                                      <table className="table credit-breakdown-table">
                                        <thead>
                                          <tr>
                                            <th className="discipline-column">
                                              <i className="bi bi-book me-2"></i>
                                              <span className="column-header-text">Discipline Name</span>
                                            </th>
                                            <th className="credit-column text-end">
                                              <i className="bi bi-award me-2"></i>
                                              <span className="column-header-text">Course type</span>
                                            </th>
                                            <th className="credit-column text-end">
                                              <i className="bi bi-award me-2"></i>
                                              <span className="column-header-text">Credits</span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="lin-ht">
                                          {disciplinewiseCreditData.map((item, index) => (
                                            <tr key={index}>
                                              <td className="discipline-name">
                                                {item.discipline_name}
                                              </td>
                                              <td className="credit-value text-end">
                                                {item.paper_identifier}
                                              </td>
                                              <td className="credit-value text-end">
                                                {item.total_acquired_credit}
                                              </td>
                                            </tr>
                                          ))}
                                          <tr> <td className="total-label">
                                            <i className="bi bi-plus-circle-fill me-2"></i>
                                            <strong className="total-label-text">Total Acquired Credits</strong>
                                          </td> <td className="credit-value text-end">
                                              <strong className="total-number" style={{ color: "black" }}>{totalCredits}</strong>

                                            </td></tr>
                                        </tbody>

                                      </table>
                                    </div>
                                  </div>

                                </div>
                                {/* <div className="modal-footer credit-modal-footer">
                                  <button
                                    type="button"
                                    className="btn credit-modal-btn-close"
                                    data-bs-dismiss="modal"
                                  >
                                    <i className="bi bi-x-lg me-2"></i>
                                    <span className="btn-close-text">Close</span>
                                  </button>
                                </div> 
                              </div>
                            </div>
                          </div>
                        )} */}
                        {disciplinewiseCreditData && disciplinewiseCreditData.length > 0 && (
                          <div className="credit-modal-section">
                            <div className="modal fade" id="creditDetailsModal" tabIndex="-1" aria-labelledby="creditDetailsModalLabel" aria-hidden="true">
                              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <div className="d-flex align-items-center gap-3">
                                      <div className="credit-icon-wrapper icn1">
                                        <i className="bi bi-award icn-clr"></i>
                                      </div>
                                      <div>
                                        <h5 className="modal-title mb-0" id="creditDetailsModalLabel">Credit Details</h5>
                                      </div>
                                    </div>
                                    <button type="button" className="btn-close icn1 close-btn-border" data-bs-dismiss="modal" aria-label="Close">
                                    </button>
                                  </div>

                                  <div className="modal-body">
                                    {/* Overall Summary - Matching Image Style */}
                                    <div className="overall-summary-card mb-4">
                                      <div className="summary-header">
                                        <h6 className="mb-0">
                                          <i className="bi bi-pie-chart-fill me-2"></i>
                                          Overall Summary
                                        </h6>
                                      </div>
                                      <div className="summary-content">
                                        <div className="summary-row">
                                          <div className="summary-item">
                                            <div className="summary-label">Disciplines</div>
                                            <div className="summary-value">{totalDisciplines}</div>
                                          </div>
                                          <div className="summary-item">
                                            <div className="summary-label">Total Credits</div>
                                            <div className="summary-value total-credits">{totalCredits}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Discipline List - Keep original accordion style */}
                                    <div className="discipline-breakdown-section mb-4">
                                      <h6 className="mb-3 border-bottom pb-2">
                                        <i className="bi bi-list-check me-2"></i>
                                        Discipline-wise Credits
                                      </h6>

                                      {/* <div className="accordion" id="creditAccordion">
                {(() => {
                  // Group by first 3 letters of course_discipline_component_code
                  const groupedData = {};
                  disciplinewiseCreditData.forEach(item => {
                    const componentCode = item.course_discipline_component_code;
                    const componentGroup = componentCode ? componentCode.substring(0, 3) : 'N/A';
                    
                    if (!groupedData[componentGroup]) {
                      groupedData[componentGroup] = {
                        total: 0,
                        disciplines: []
                      };
                    }
                    
                    // Check if discipline already exists in this group
                    const existingDiscipline = groupedData[componentGroup].disciplines.find(
                      d => d.discipline_name === item.discipline_name
                    );
                    
                    if (existingDiscipline) {
                      // Add to existing discipline's total
                      existingDiscipline.total_credit += parseFloat(item.total_acquired_credit) || 0;
                      existingDiscipline.courses.push({
                        component_code: item.course_discipline_component_code,
                        credit: parseFloat(item.total_acquired_credit) || 0
                      });
                    } else {
                      // Create new discipline entry
                      groupedData[componentGroup].disciplines.push({
                        discipline_name: item.discipline_name,
                        total_credit: parseFloat(item.total_acquired_credit) || 0,
                        courses: [{
                          component_code: item.course_discipline_component_code,
                          credit: parseFloat(item.total_acquired_credit) || 0
                        }]
                      });
                    }
                    
                    groupedData[componentGroup].total += parseFloat(item.total_acquired_credit) || 0;
                  });

                  return Object.entries(groupedData).map(([componentGroup, data], index) => (
                    <div key={componentGroup} className="accordion-item mb-2 border rounded-3">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed py-3"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse${index}`}
                        >
                          <div className="d-flex justify-content-between align-items-center w-100 me-3">
                            <div className="d-flex align-items-center">
                              <span className="fw-semibold me-2">{componentGroup}</span>
                              <i className="bi bi-chevron-down accordion-arrow"></i>
                            </div>
                            <span className="badge bg-success rounded-pill">
                              {data.total} credits
                            </span>
                          </div>
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className="accordion-collapse collapse"
                        data-bs-parent="#creditAccordion"
                      >
                        <div className="accordion-body pt-2 pb-3">
                          <div className="table-responsive">
                            <table className="table table-borderless table-hover mb-0">
                              <thead>
                                <tr>
                                  <th className="text-muted small">Discipline Name</th>
                                  <th className="text-muted small text-end">Credits</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.disciplines.map((discipline, disciplineIndex) => (
                                  <tr key={disciplineIndex}>
                                    <td>
                                      <i className="bi bi-book text-primary me-2"></i>
                                      {discipline.discipline_name}
                                    </td>
                                    <td className="text-end fw-semibold text-success">
                                      {discipline.total_credit}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                              {data.disciplines.some(d => d.courses.length > 0) && (
                                <tbody className="border-top">
                                  <tr>
                                    <td colSpan="2" className="small text-muted pt-3 pb-1">
                                      Component Details:
                                    </td>
                                  </tr>
                                  {data.disciplines.map((discipline, disciplineIndex) => (
                                    discipline.courses.map((course, courseIndex) => (
                                      <tr key={`${disciplineIndex}-${courseIndex}`} className="small">
                                        <td className="ps-4">
                                          <i className="bi bi-arrow-return-right text-secondary me-2"></i>
                                          {course.component_code}
                                        </td>
                                        <td className="text-end">{course.credit}</td>
                                      </tr>
                                    ))
                                  ))}
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  ));
                })()}
              </div>   */}

                                      <div className="accordion" id="creditAccordion">
                                        {(() => {
                                          // Group by first 3 letters of course_discipline_component_code
                                          const groupedData = {};
                                          disciplinewiseCreditData.forEach(item => {
                                            const componentCode = item.course_discipline_component_code;
                                            const componentGroup = componentCode ? componentCode.substring(0, 3) : 'N/A';

                                            if (!groupedData[componentGroup]) {
                                              groupedData[componentGroup] = {
                                                total: 0,
                                                disciplines: []
                                              };
                                            }

                                            // Check if discipline already exists in this group
                                            const existingDiscipline = groupedData[componentGroup].disciplines.find(
                                              d => d.discipline_name === item.discipline_name
                                            );

                                            if (existingDiscipline) {
                                              // Add to existing discipline's total
                                              existingDiscipline.total_credit += parseFloat(item.total_acquired_credit) || 0;
                                              existingDiscipline.courses.push({
                                                component_code: item.course_discipline_component_code,
                                                credit: parseFloat(item.total_acquired_credit) || 0
                                              });
                                            } else {
                                              // Create new discipline entry
                                              groupedData[componentGroup].disciplines.push({
                                                discipline_name: item.discipline_name,
                                                total_credit: parseFloat(item.total_acquired_credit) || 0,
                                                courses: [{
                                                  component_code: item.course_discipline_component_code,
                                                  credit: parseFloat(item.total_acquired_credit) || 0
                                                }]
                                              });
                                            }

                                            groupedData[componentGroup].total += parseFloat(item.total_acquired_credit) || 0;
                                          });

                                          return Object.entries(groupedData).map(([componentGroup, data], index) => (
                                            <div key={componentGroup} className="accordion-item mb-2 border rounded-3">
                                              <h2 className="accordion-header">
                                                <button
                                                  className="accordion-button collapsed py-3"
                                                  type="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`#collapse${index}`}
                                                  aria-expanded="false"
                                                  aria-controls={`collapse${index}`}
                                                >
                                                  <div className="d-flex justify-content-between align-items-center w-100 me-3">
                                                    <div className="d-flex align-items-center">
                                                      <span className="fw-semibold me-2">{componentGroup}</span>
                                                      <i className="bi bi-chevron-down accordion-arrow"></i>
                                                    </div>
                                                    <span className="badge bg-success rounded-pill">
                                                      {data.total} credits
                                                    </span>
                                                  </div>
                                                </button>
                                              </h2>
                                              <div
                                                id={`collapse${index}`}
                                                className="accordion-collapse collapse"
                                                data-bs-parent="#creditAccordion"
                                              >
                                                <div className="accordion-body pt-2 pb-3">
                                                  <div className="table-responsive">
                                                    <table className="table table-borderless table-hover mb-0">
                                                      <thead>
                                                        <tr>
                                                          <th className="text-muted small">Disciplines</th>
                                                          <th className="text-muted small text-end">Credits</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {data.disciplines.map((discipline, disciplineIndex) => {
                                                          // Join all component codes for this discipline
                                                          const componentCodes = discipline.courses.map(course => course.component_code).join(', ');

                                                          return (
                                                            <tr key={disciplineIndex}>
                                                              <td>
                                                                <div className="d-flex align-items-center">
                                                                  <i className="bi bi-book text-primary me-2"></i>
                                                                  <div>
                                                                    <div className="fw-medium">{discipline.discipline_name}</div>
                                                                    {/* <div className="small text-muted mt-1">
                                <i className="bi bi-tag me-1"></i>
                                {componentCodes}
                              </div> */}
                                                                  </div>
                                                                </div>
                                                              </td>
                                                              <td className="text-end fw-semibold text-success">
                                                                {discipline.total_credit}
                                                              </td>
                                                            </tr>
                                                          );
                                                        })}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ));
                                        })()}
                                      </div>
                                    </div>

                                    {/* Grand Total */}
                                    <div className="card border-success bg-light">
                                      <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            <h6 className="text-success mb-1">
                                              <i className="bi bi-check-all me-2"></i>
                                              Grand Total
                                            </h6>
                                            <p className="text-muted small mb-0">All acquired credits</p>
                                          </div>
                                          <div className="text-end">
                                            <h3 className="text-success mb-0">{totalCredits}</h3>
                                            <p className="text-muted small mb-0">credits</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* Credit Modal End */}

                      </div>
                    </div>
                  </div>
                </div>
              </div>






              {/* Discipline/College wsitch history  end */}

              <div className="card tranaction-card">
                <div className="card-header card-no-border">
                  <div className="d-flex justify-content-center align-items-center mb-4">
                    <h4 className="mb-0 text-dark text-center mobile">
                      Semester wise course information
                    </h4>
                  </div>

                  <div className="semester-tabs-wrapper">
                    <select className="form-select d-md-none mb-3" onChange={(e) => handleCoTabClick(e.target.value, parseInt(e.target.selectedOptions[0].getAttribute('data-sem-num')))}>
                      <option value="semester1" data-sem-num="1">Semester 1</option>
                      <option value="semester2" data-sem-num="2">Semester 2</option>
                      <option value="semester3" data-sem-num="3">Semester 3</option>
                      <option value="semester4" data-sem-num="4">Semester 4</option>
                      <option value="semester5" data-sem-num="5">Semester 5</option>
                      <option value="semester6" data-sem-num="6">Semester 6</option>
                      <option value="semester7" data-sem-num="7">Semester 7</option>
                      <option value="semester8" data-sem-num="8">Semester 8</option>
                    </select>

                    <div className="st-dash-sem-tab d-none d-md-block">
                      <div className="semester-tabs">
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((semNum) => (
                          <button
                            key={semNum}
                            className={`semester-tab ${activecoTab === `semester${semNum}` ? 'active' : ''}`}
                            onClick={() => handleCoTabClick(`semester${semNum}`, semNum)}
                          >
                            Sem {semNum}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mobile-table table-bordered">
                      <thead class="table-dark">
                        <tr>
                          <th scope="col">Sl No.</th>
                          <th scope="col" width="17%">Discipline Name</th>
                          <th scope="col">Course Code</th>
                          <th scope="col">Course Name</th>
                          <th scope="col " width="14%" >Status</th>
                          <th scope="col" width="5%">College Opted</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(semesterData) && semesterData.length ? (
                          semesterData.map((course, index) => (
                            <tr key={index} class="course-row">
                              <td data-label="Sl No.">{index + 1}</td>
                              <td data-label="Discipline Name">{course.discipline_name || "-"}</td>
                              <td data-label="Course Code">{course.course_code || "-"}</td>
                              <td data-label="Course Name">{course.paper_identifier} - {course.course_name || "-"}</td>
                              <td data-label="Status">
                                <span class="d-flex align-items-center">
                                  <i class={`bi bi-${course.studentstatus === 'DEO Rejected' || course.studentstatus === 'Principal Rejected'
                                    ? 'x-circle-fill text-danger'
                                    : course.studentstatus === 'DEO Verified' || course.studentstatus === 'Principal Approved'
                                      ? 'check-circle-fill text-success'
                                      : course.studentstatus === 'Entered' ? 'circle-fill text-warning sts-btn-clr1' : 'exclamation-circle-fill text-warning'
                                    }`}></i>
                                  <span class="ms-2">
                                    {course.studentstatus === 'DEO Rejected' ? 'DEO Rejected' : course.studentstatus === 'DEO Verified' ? 'DEO Verified' : course.studentstatus === 'Principal Rejected' ? 'Principal Rejected' : course.studentstatus === 'Principal Approved' ? 'Principal Approved' : course.studentstatus === 'Entered' ? 'Entered' : 'Pending'}
                                  </span>
                                </span>
                              </td>
                              <td data-label="College Opted">
                                <span class={`badge ${course.student_college_type === 'Own College'
                                  ? 'bg-success'
                                  : course.student_college_type === 'Other College'
                                    ? 'bg-danger'
                                    : 'text-dark'
                                  }`}>
                                  {course.student_college_type}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" class="text-center p-4 text-muted">
                              <i class="bi bi-info-circle me-2"></i>No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>


              </div>



              <div className="notification box-col-6">
                <div className="card clg-card-ht1">
                  <div className="card-header mobile1">
                    <h5>Latest Activity</h5>
                  </div>
                  <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht5">
                    <ul>
                      {flag > 0 ? (
                        userlog.map((log, index) => (
                          <li className="d-flex" key={index}>
                            <div className={`${index % 2 ? 'activity-dot-primary' : 'activity-dot-warning'} zstl`} />
                            <div className="w-100 ms-3">
                              <p className="d-flex justify-content-between mb-2 clg-not-cd-fnt">
                                <span className="date-content light-background pdg13">{formatDate(log.created_at)}</span>
                                <span>{formatRelativeDate(log.created_at)}</span>
                              </p>
                              <h6 className="clg-not-cd-fnt-h">{log.master_user_action.user_action}<span className="dot-notification" /></h6>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="d-flex">
                          <div className="activity-dot-primary zstl" />
                          <div className="w-100 ms-3">
                            <h6>No Log Data Available<span className="dot-notification" /></h6>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div >



      </StudentTemplate >
    </>
  );
};

export default Home;